export default __webpack_public_path__ + "static/media/vivabonito11.6fac1861.jpg";